import { Skeleton, Typography } from '@mui/material';
import { TextContainer as Container, Category, Name, Description } from '@/components/navigation/NavigationIntroScreen/components/Popup/styles';

export const TextContainer = ({ rtl, contentLoaded, item, isMobile }) => {
  return (
    <Container
      rtl={rtl}
      style={{
        padding: '14px',
        marginTop: '0px',
      }}
    >
      {contentLoaded ? (
        <>
          {item?.category && (
            <Category style={{ fontFamily: 'Inter, Heebo, sans-serif', fontWeight: 400, fontSize: '12px', lineHeight: '29px', direction: rtl ? 'rtl' : 'ltr' }}>
              {item?.category?.title}
            </Category>
          )}
          <Name style={{ fontFamily: 'Inter, Heebo, sans-serif', fontSize: '16px', margin: '6px 0px', fontWeight: rtl ? 500 : 600, direction: rtl ? 'rtl' : 'ltr' }}>
            {item[item.type]?.title || item?.title || item?.name}
          </Name>
        </>
      ) : (
        <>
          <Skeleton variant="text" sx={{ fontSize: isMobile ? '14px' : '16px' }} width={210} />
          <Skeleton variant="text" sx={{ fontSize: isMobile ? '14px' : '16px' }} width={210} />
        </>
      )}
      {item?.tag?.description && (
        <>
          <Description rtl={rtl}>
            {contentLoaded ? (
              <Typography
                sx={{
                  lineHeight: '18px',
                  color: 'rgba(0, 0, 0, 0.5)',
                  fontSize: '12px',
                  wordBreak: 'break-word',
                }}
                dangerouslySetInnerHTML={{ __html: item?.tag?.description }}
              />
            ) : (
              <>
                <Skeleton variant="text" sx={{ fontSize: isMobile ? '14px' : '16px' }} />
                <Skeleton variant="text" sx={{ fontSize: isMobile ? '14px' : '16px' }} />
                <Skeleton variant="text" sx={{ fontSize: isMobile ? '14px' : '16px' }} />
              </>
            )}
          </Description>
        </>
      )}
    </Container>
  );
};
